<script setup lang="ts">
import { shallowRef, watchEffect } from 'vue';

const props = defineProps<{
  value: string;
  formatInput(input: string): string;
  formatModel(input: string): string;
}>();

const emit = defineEmits<{ (event: 'input', value: string): void }>();

const localModel = shallowRef(props.value);
watchEffect(
  () => {
    const formattedInput = props.formatInput(localModel.value);
    localModel.value = formattedInput === props.value ? localModel.value : formattedInput;
  },
  { flush: 'sync' }
);
watchEffect(() => emit('input', props.formatModel(localModel.value)), {
  flush: 'sync',
});

function onInput(event: Event) {
  if (!(event.target instanceof HTMLInputElement) || !(event instanceof InputEvent)) return;
  localModel.value = event.target.value = props[
    event.inputType === 'insertFromPaste' ? 'formatModel' : 'formatInput'
  ](event.target.value);
}
</script>

<template>
  <input :value="localModel" @input="onInput" />
</template>
